<template>
  <div class="flex flex-col justify-between">
    <el-form ref="formRef" label-position="top" :model="form" size="large" @submit.prevent="submit">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item :label="$t('admin.user.form.labels.email')" prop="email" :rules="[
            { required: true, message: $t('admin.user.form.validation.email.required'), trigger: 'blur' },
            { type: 'email', message: $t('admin.user.form.validation.email.invalid'), trigger: 'blur' }
          ]">
            <el-input v-model="form.email" :placeholder="$t('admin.user.form.placeholders.email')" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item :label="$t('admin.user.form.labels.name')" prop="name" :rules="[
            { required: true, message: $t('admin.user.form.validation.name.required'), trigger: 'blur' }
          ]">
            <el-input v-model="form.name" :placeholder="$t('admin.user.form.placeholders.name')" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item :label="$t('admin.user.form.labels.phone')" prop="phone" :rules="[
            { required: true, message: $t('admin.user.form.validation.phone.required'), trigger: 'blur' },
            { pattern: /^1[3-9]\d{9}$/, message: $t('admin.user.form.validation.phone.invalid'), trigger: 'blur' }
          ]">
            <el-input v-model="form.phone" :placeholder="$t('admin.user.form.placeholders.phone')" />
          </el-form-item>
        </el-col>

        <el-col v-if="!isEdit" :span="8">
          <el-form-item :label="$t('admin.user.form.labels.password')" prop="password" :rules="[
            { required: !isEdit, message: $t('admin.user.form.validation.password.required'), trigger: 'blur' },
            { min: 6, message: $t('admin.user.form.validation.password.minLength'), trigger: 'blur' }
          ]">
            <el-input v-model="form.password" type="password" :placeholder="$t('admin.user.form.placeholders.password')" />
          </el-form-item>
        </el-col>
        <el-col v-if="!isEdit" :span="8">
          <el-form-item :label="$t('admin.user.form.labels.passwordConfirmation')" prop="passwordConfirmation" :rules="[
            { required: !isEdit, message: $t('admin.user.form.validation.passwordConfirmation.required'), trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (value !== form.value.password) {
                  callback(new Error($t('admin.user.form.validation.passwordConfirmation.notMatch')))
                } else {
                  callback()
                }
              },
              trigger: 'blur'
            }
          ]">
            <el-input v-model="form.passwordConfirmation" type="password" :placeholder="$t('admin.user.form.placeholders.passwordConfirmation')" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('admin.user.form.labels.roles')" prop="roleIds"
            :rules="[{ required: true, message: $t('admin.user.form.validation.roles.required'), trigger: 'blur' }]">
            <el-select v-model="form.roleIds" :options="options.roles" :placeholder="$t('admin.user.form.placeholders.roles')"
              multiple clearable>
              <el-option v-for="role in options.roles" :key="role.id" :label="role.name" :value="role.id" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script setup>
const props = defineProps({
  target: {
    type: Object,
    default: () => ({}),
  },
  options: {
    type: Object,
    default: () => ({
      roles: [],
    }),
  },
})

const { t } = useI18n()
const emit = defineEmits(['close', 'submit'])
const formRef = ref(null)
const loading = ref(false)

const form = ref(props.target ? { ...props.target } : {
  id: '',
  email: '',
  name: '',
  phone: '',
  password: '',
  passwordConfirmation: '',
  roleIds: []
})

// 判断是否为编辑模式
const isEdit = computed(() => Boolean(props.target?.id))

// 提交表单
const submit = async () => {
  try {
    loading.value = true
    const invalid = await formRef.value?.validate()
    if (invalid) return false

    router.post(routes.upsert_admin_sys_users(), form.value, {
      onSuccess: () => { emit('close') },
      onFinish: () => {
        loading.value = false
      }
    })
  } catch (error) {
    // 其他错误（如网络错误、服务器错误等）
    ElMessage.error(error.message || '保存失败，请重试')
    loading.value = false
  }
}

// 关闭表单
const close = () => { emit('close') }

// 监听 target 变化，更新表单数据
watchEffect(() => {
  if (props.target) form.value = { ...props.target }
})

defineExpose({ submit })
</script>
